import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'joinWithKey',
})
export class JoinWithKeyPipe implements PipeTransform {
  public transform(value: any[], key: string): string {
    if (!Array.isArray(value)) {
      return value;
    }

    return joinWithKey(value, key);
  }
}

export function joinWithKey(arr: any[], key: string) {
  if (arr.length === 1) {
    return arr[0][key];
  }
  return arr.map((obj) => obj[key]).join(', ');
}
